"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _setupFormHandler = function ($) {
    $(document).on('submit', 'form', function () {
        var $form = $(this);
        var csrfToken = getCookie('csrf_token');
        if (!csrfToken) {
            return;
        }
        var $inputField = $form.find('input[name="_X_CSRF_TOKEN"]');
        if ($inputField.length) {
            $inputField.attr('name', '_X_CSRF_TOKEN');
            $inputField.attr('value', csrfToken);
        }
        else {
            var $csrfInput = $('<input>', {
                type: 'hidden',
                name: '_X_CSRF_TOKEN',
                value: csrfToken,
            });
            $form.append($csrfInput);
        }
        return true;
    });
};
exports.default = _setupFormHandler;
